import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axiosInstance from "../../config/axiosConfig";
import config from "../../config/api";


const BackendURL = config.backendUrl;

export const updateTaskStatus = createAsyncThunk(
    "project/updateTaskStatus",
    async ({ projectid, userid }, { rejectWithValue }) => {
        try {
            const response = await axiosInstance.post(
                `${BackendURL}/submit-task/status`,
                { projectid, userid }
            );

            return response.data;
        } catch (error) {
            return rejectWithValue(
                error.response?.data || { message: "Something went wrong" }
            );
        }
    }
);

const projectTaskStatusSlice = createSlice({
    name: "projectTaskStatus",
    initialState: {
        loading: false,
        success: null,
        error: null,
        updatedProject: null,
    },

    reducers: {
        resetTaskStatusState: (state) => {
            state.loading = false;
            state.success = null;
            state.error = null;
            state.updatedProject = null;
        },
    },

    extraReducers: (builder) => {
        builder
            // ⏳ Pending
            .addCase(updateTaskStatus.pending, (state) => {
                state.loading = true;
                state.error = null;
                state.success = null;
            })

            // ✅ Fulfilled
            .addCase(updateTaskStatus.fulfilled, (state, action) => {
                state.loading = false;
                state.success = action.payload.message;
                state.updatedProject = action.payload.project;
            })

            // ❌ Rejected
            .addCase(updateTaskStatus.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload?.message || "Failed to update task status";
            });
    }
});

export const { resetTaskStatusState } = projectTaskStatusSlice.actions;

export default projectTaskStatusSlice.reducer;
